import {Security} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import AuthClaims from './AuthClaims';

export const authClaims: FeatureObject = {
  type: 'settings',
  title: 'Auth Claims',
  description: 'View and refresh Firebase Auth custom claims (admin only)',
  path: '/settings/auth-claims',
  component: (user) => <AuthClaims user={user} />,
  IconComponent: Security,
  status: FeatureStatus.ADMIN,
  tags: [],
  permission: 'owner',
};
